import { render, staticRenderFns } from "./ContactLastMessage.vue?vue&type=template&id=447d7c2b&scoped=true"
import script from "./ContactLastMessage.vue?vue&type=script&lang=js"
export * from "./ContactLastMessage.vue?vue&type=script&lang=js"
import style0 from "./ContactLastMessage.vue?vue&type=style&index=0&id=447d7c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d7c2b",
  null
  
)

export default component.exports